'use client'

import { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'

// Dynamically import the Filter component for mobile
const Filter = dynamic(() => import('./Filter'), {
  loading: () => (
    <div className="h-10 w-full bg-gray-100 animate-pulse rounded border"></div>
  ),
  ssr: false
})

interface LazyMobileFilterProps {
  searchParams: { [key: string]: string | string[] | undefined }
}

export default function LazyMobileFilter({ searchParams }: LazyMobileFilterProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <div className="h-10 w-full bg-gray-100 animate-pulse rounded border"></div>
    )
  }

  return (
    <div className="lg:hidden px-2 mb-4">
      <Filter searchParams={searchParams} />
    </div>
  )
}
